import KategoriPenilai from "../../../../../components/categories/siakad/laporan_adab/kategori_penilai/Home";
export default function Home() {
  
  return (
    <KategoriPenilai />
  );
}
